<template>
    <div>
        <p>Tableau</p>

        <p>
            Toutes les colonnes
            <b-checkbox style="display:inline-block" v-model="all_columns" />
            Non editable
            <b-checkbox style="display:inline-block"  v-model="all_columns_no_edit" />
        </p>

        <draggable :group="'array'" :list="columns_type" class="list-group" handle=".handle">
            <b-card v-for="(params, idx) in columns_type" :key="idx + '_' + params.black_white_lists + '_' + params.black_white_lists_edit + '_' + params.splash + '_' + params.parent_categories + '_' + params.uniq + '_' + params.edit">
                <b-container style="margin: 0; padding: 0; max-width: none;">
                    <b-row>
                        <b-col cols="6">
                            Colonne
                            <b-input v-model="params.column"></b-input>
                        </b-col>
                        <b-col cols="6">                            
                            type
                            <b-select @change="construct_params(idx)" v-model="params.type" :options="options_type"></b-select>
                        </b-col>
                        <b-col cols="6">                            
                            Largeur de la colonne
                            <b-input @change="construct_params(idx)" v-model="params.width"></b-input>
                        </b-col>
                        <b-col cols="6">                            
                            Largeur de la colonne - mode individuel
                            <b-select @change="construct_params(idx)" v-model="params.size" :options="['', 1,2,3,4,5,6,7,8,9,10,11,12]"></b-select>
                        </b-col>
                        <b-col cols="3" v-show="params.type == 'text'">
                            Type de texte
                            <b-select @change="construct_params(idx)" v-model="params.text_type" :options="['simple', 'textarea', 'html', 'json', 'url']"></b-select>
                        </b-col>
                        <b-col cols="3" v-show="params.type == 'image' || params.type == 'video'">Whitelists et blacklists
                            <b-checkbox @change="construct_params(idx)" v-model="params.black_white_lists"></b-checkbox>
                        </b-col>
                        <b-col cols="3" v-show="params.type == 'image' || params.type == 'video'">Whitelists et blacklists - edition
                            <b-checkbox @change="construct_params(idx)" v-model="params.black_white_lists_edit"></b-checkbox>
                        </b-col>
                        <b-col cols="3" v-show="params.type == 'image'">Splash
                            <b-checkbox @change="construct_params(idx)" v-model="params.splash"></b-checkbox>
                        </b-col>
                        <b-col cols="3" v-show="params.type == 'category_splash'">Catégories parentes
                            <b-checkbox @change="construct_params(idx)" v-model="params.parent_categories"></b-checkbox>
                        </b-col>
                        <b-col cols="3" v-show="params.type == 'image' || params.type == 'category_splash'">Unique
                            <b-checkbox @change="construct_params(idx)" v-model="params.uniq"></b-checkbox>
                        </b-col>
                        <b-col cols="3" v-show="params.type == 'image' && params.uniq == true">Limiter la taille (en pixels)
                            <b-input type="number" @change="construct_params(idx)" v-model.number="params.resize_image"></b-input>
                        </b-col>
                        <b-col cols="3" v-show="params.type != 'list'">Editable
                            <b-checkbox @change="construct_params(idx)" v-model="params.edit"></b-checkbox>
                        </b-col>
                        <b-col cols="3" v-show="params.type == 'list'">Liste de valeurs séparées par un |
                            <b-input @change="construct_params(idx)" v-model="params.list"></b-input>
                        </b-col>
                    </b-row>
                </b-container>

                <div v-if="params.type == 'list_db'">
                    Table
                    <b-input v-model="params.params.table"></b-input>
                    Colonne id
                    <b-input v-model="params.params.table_column"></b-input>
                    Colonnes
                    <draggable :group="'array-' + idx" :list="params.params.table_columns" class="list-group" handle=".handle">
                        <div v-for="(item, column_idx) in params.params.table_columns" :key="column_idx">
                            Nom <b-input style="display:inline; width: 300px" v-model="item.column"></b-input>
                            Filtre <b-select style="display:inline; width: 150px" v-model="item.filter" :options="[
                                {value: false, text: ''},
                                {value: 'radio', text: 'Bouton'},
                                {value: 'list', text: 'Liste'}
                            ]"></b-select>
                            <!-- Recherche <b-select style="display:inline; width: 150px" v-model="item.search" :options="[
                                {value: false, text: 'Non'},
                                {value: true, text: 'Oui'}
                            ]"></b-select>-->
                            <b-button variant="link" class="handle"><i class="fas fa-arrows-alt"></i></b-button>
                            <b-button variant="link" @click="params.params.table_columns.splice(column_idx, 1);"><i class="fas fa-trash"></i></b-button>
                        </div>
                    </draggable>

                    <b-button variant="link" @click="params.params.table_columns.push({column: '', filter: '', search: true})"><i class="fas fa-plus"></i></b-button>
                </div>

                <b-button variant="link" class="handle"><i class="fas fa-arrows-alt"></i></b-button>
                <b-button variant="link" @click="delete_column(idx)"><i class="fas fa-trash"></i></b-button>
            </b-card>
        </draggable>
        <br />
        <b-button @click="add_column">Ajouter une colonne</b-button>

        <actionBuilder :delete_option="false" :projects_obj="projects_obj" :projects="projects" ref="actionBuilder"></actionBuilder>

        <br />

        <configurationBuilder :projects_obj="projects_obj" :projects="projects"  ref="configurationBuilder"></configurationBuilder>

        <hr />
        <b-form-checkbox v-model="chart_enable" switch class="mt-2">Graphiques {{ chart_enable ? '(activé)' : '(désactivé)' }}</b-form-checkbox>
        <div v-if="chart_enable" class="mt-2">
            <chart-config :value="chart_configs" :columns="chartColumns" @input="chart_configs = $event" />
        </div>
    </div>

</template>

<script>
	import configurationBuilder from "./configurationBuilder.vue";
	import actionBuilder from "./actionBuilder.vue";
	import ChartConfig, { defaultChartConfig } from "../ChartConfig.vue";
	import draggable from "vuedraggable";

    export default {
        name: "arrayBuilder",
		components: {
            configurationBuilder,
            actionBuilder,
            ChartConfig,
            draggable
        },
        props: {
            params: {},
            projects: {},
            projects_obj: {}
        },
        data: function () {
            return {
                all_columns: false,
                all_columns_no_edit: false,
                columns_type: [],
                chart_enable: false,
                chart_configs: [defaultChartConfig()],
                options_type: [
                    {value: 'text', text: 'Texte'},
                    {value: 'list', text: "Liste"},
                    {value: 'list_db', text: "Liste - base de données"},
                    {value: 'boolean', text: "Case à cochée"},
                    {value: 'image', text: "Image"},
                    {value: 'video', text: "Video"},
                    {value: 'category', text: "Catégorie"},
                    {value: 'category_splash', text: "Catégorie Splash"},
                    {value: 'file', text: "Fichier (xml/dox/pdf/image)"},
                    {value: 'file_zoom', text: "Pdf avec zoom"},
                    {value: 'url', text: "Url"},
                ]
            };
		},
		computed: {
            chartColumns() {
                return this.columns_type.map(ct => ct.column).filter(c => c);
            }
        },
		methods: {
            async construct_params(idx)
            {
                var params = {
                    editor: this.columns_type[idx].edit,
                    width: parseInt(this.columns_type[idx].width),
                    black_white_lists: this.columns_type[idx].black_white_lists,
                    black_white_lists_edit: this.columns_type[idx].black_white_lists_edit,
                    text_type: this.columns_type[idx].text_type
                };

                if (this.columns_type[idx].type == "image")
                {
                    params.splash = this.columns_type[idx].splash;
                }

                if (this.columns_type[idx].type == "list")
                {
                    params.editor = "select"
                    params.editorParams = {values:this.columns_type[idx].list.split("|").map(s => s.trim())};
                }

                if (this.columns_type[idx].type == "boolean")
                {
                    params.formatter = "tickCross";
                }
                
                if (this.columns_type[idx].type == "list_db")
                {
                    params.table = "";
                    params.table_column = "";
                    params.table_columns = [];
                }

                if (this.columns_type[idx].type == "category_splash")
                {
                    params.parent_categories = this.columns_type[idx].parent_categories;
                    params.uniq = this.columns_type[idx].uniq;
                }

                // Utiliser $set pour forcer la réactivité Vue
                this.$set(this.columns_type[idx], 'params', params);
                
                // Force aussi un re-render du composant
                this.$forceUpdate();
            },
            async delete_column(idx)
            {
                this.columns_type.splice(idx, 1);
            },
            async add_column()
            {
                this.columns_type.push({
                    column: "",
                    type: "text",
                    edit: true,
                    list: "",
                    width: "250",
                    black_white_lists: false,
                    black_white_lists_edit: false,
                    text_type: 'simple',
                    params: {},
                    actions: []
                });
            },
            async save()
            {
                var result = {
                    columns_type: this.columns_type,
                    actions:  await this.$refs.actionBuilder.save(),
                    configuration: await this.$refs.configurationBuilder.save(),
                    all_columns: this.all_columns,
                    all_columns_no_edit: this.all_columns_no_edit,
                    chart_enable: this.chart_enable,
                    chart_configs: this.chart_configs
                };
                return result;
            },
            async load(data)
            {                
                this.columns_type = data.columns_type || [];
                this.all_columns = data.all_columns || false;
                this.all_columns_no_edit = data.all_columns_no_edit || null;
                this.chart_enable = data.chart_enable || false;
                this.chart_configs = (data.chart_configs && data.chart_configs.length) ? data.chart_configs : [defaultChartConfig()];

                if (data.actions)
                    await this.$refs.actionBuilder.load(data.actions);

                if (data.configuration)
                    await this.$refs.configurationBuilder.load(data.configuration);
            }
		},
		mounted: function () {
            if (this.params)
                this.load(this.params)
		},
    }


</script>